import { createFileRoute } from '@tanstack/react-router';

import '@/routes/-routeStaticData';
import { ViewReceiptImagePage } from './ViewReceiptImagePage';

export const Route = createFileRoute('/_protected/_consumer/receipts/$receiptId/view-image/')({
  component: ViewReceiptImagePage,
  // A full-screen viewer: the floating nav pill would otherwise sit over the
  // bottom of the receipt. The route stays inside `_consumer` so navigating
  // here never remounts ChatSessionProvider.
  staticData: { hideBottomNav: true },
});
